import React from 'react';
import Consulting from '../components/Consulting';
import Contact from '../components/Contact';
import '../styles/Consulting.css';

const ConsultingPage: React.FC = () => {
  return (
    <>
      <Consulting />
      <Contact />
    </>
  );
};

export default ConsultingPage;
